export interface CaptionTransitions {
  pageIn?: TransitionInEffect;
  wordIn?: TransitionInEffect;
}

export enum TransitionInEffect {
  None = 'none',
  Fade = 'fade',
  SlideUp = 'slideUp',
  Spring = 'spring',
  Appear = 'appear'
}

export enum SpeakerLabelTransitionEffect {
  None = 'none',
  MoveLeft = 'moveLeft',
  MoveBottom = 'moveBottom',
  Scale = 'scale',
  Fade = 'fade',
  Mask = 'mask'
}

export interface SpeakerLabelTransitions {
  in: SpeakerLabelTransitionEffect;
  out: SpeakerLabelTransitionEffect;
  showAfter: number;
  hideAfter: number | undefined;
  showAgainOnNewSpeaker: boolean;
  duration: number;
}
